<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>General List</h5>
                </div>
                <div class="card-body">
                    <div class="btn-popup pull-right">
                        <!--<button type="button" class="btn btn-primary" data-toggle="modal" data-original-title="test"-->
                                <!--data-target="#exampleModal" (click)="open(content)">Add Category</button>-->
                        <ng-template #content let-modal>
                            <div class="modal-header">
                                <h5 class="modal-title f-w-600" id="exampleModalLabel">Add Physical Product</h5>
                                <button type="button" class="close" aria-label="Close"
                                        (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form [formGroup]="addCategoryForm" class="needs-validation">
                                    <div class="form">
                                        <div class="form-group">
                                            <label class="mb-1">Is Parent Category :</label><br>
                                            <div class="form-check-inline">
                                                <label class="form-check-label">
                                                    <input type="radio" formControlName="is_parent" class="form-check-input" value="yes">Yes
                                                </label>
                                            </div>
                                            <div class="form-check-inline">
                                                <label class="form-check-label">
                                                    <input type="radio" formControlName="is_parent" class="form-check-input" value="no">No
                                                </label>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="validationCustom01" class="mb-1">Category Name :</label>
                                            <input class="form-control" formControlName="category_name" id="validationCustom01" type="text">
                                        </div>
                                        <div class="form-group">
                                            <label for="validationCustom02"  class="mb-1">Description :</label>
                                            <input class="form-control" formControlName="description" id="validationCustom02" type="text">
                                        </div>
                                        <div class="form-group row" *ngIf="addCategoryForm.controls.is_parent.value == 'no'">
                                            <label class="col-xl-3 col-md-4">Parent Category</label>
                                            <select class="custom-select col-md-7" formControlName="parent_category" required="">
                                                <option value="">--Select--</option>
                                                <option *ngFor="let item of products" value="{{item.category_id}}">{{item.category_name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-secondary" type="button" data-dismiss="modal"
                                        (click)="modal.dismiss('Cross click')">Close</button>
                            </div>
                        </ng-template>
                    </div>
                    <div id="batchDelete" class="category-table custom-datatable">
                        <div class="table-responsive">
<!--                            <angular2-smart-table [settings]="settings" [source]="products"></angular2-smart-table>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Container-fluid Ends-->
